(function ($, Drupal, once) {
  'use strict';

  if (typeof $.cookie !== 'function') {
    $.cookie = function (name, value, options) {
      if (typeof value === 'undefined') {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : undefined;
      }

      options = options || {};
      var cookieString = name + '=' + encodeURIComponent(value);
      if (options.path) {
        cookieString += '; path=' + options.path;
      }
      if (options.expires) {
        var expires = options.expires instanceof Date
          ? options.expires
          : new Date(Date.now() + options.expires * 864e5);
        cookieString += '; expires=' + expires.toUTCString();
      }
      document.cookie = cookieString;
    };
  }

  /**
   * Decoupe le cookie Customer_information en prénom/nom.
   *
   * @param {string} value
   *
   * @return {{initials: string, fullName: string}}
   */
  function parseCustomerInformation(value) {
    var parts = value.split(/[,\s]+/).filter(Boolean);

    if (parts.length === 0) {
      return { initials: '', fullName: '' };
    }

    var initials = parts.length === 1
      ? parts[0].substring(0, 2).toUpperCase()
      : (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();

    return { initials: initials, fullName: parts.join(' ') };
  }

  /**
   *
   * @return {{initials: string, fullName: string}|null}
   */
  function getConnectedCustomer() {
    var sessionExpiry = $.cookie ? $.cookie('Session_expiry') : undefined;
    var customerInformation = $.cookie ? $.cookie('Customer_information') : undefined;

    if (!sessionExpiry || !customerInformation) {
      return null;
    }

    var expiryDate = new Date(sessionExpiry);
    if (isNaN(expiryDate.getTime()) || expiryDate.getTime() < Date.now()) {
      return null;
    }

    return parseCustomerInformation(customerInformation);
  }

  Drupal.behaviors.ouigoHeaderAccount = {
    attach: function (context) {
      var customer = getConnectedCustomer();

      once('ouigo-header-account-trigger', '.ouigo-header__account-trigger', context).forEach(function (trigger) {
        var $trigger = $(trigger);
        var $menu = $trigger.siblings('.ouigo-header__account-menu');

        if (customer) {
          $trigger
            .addClass('ouigo-header__account-trigger--logged')
            .attr('href', '#')
            .find('.ouigo-header__account-trigger-text').attr('hidden', true).end()
            .find('.ouigo-header__account-initials').text(customer.initials).removeAttr('hidden');
        }

        $trigger.on('click', function (event) {
          if (!$trigger.hasClass('ouigo-header__account-trigger--logged')) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          var isOpen = $trigger.attr('aria-expanded') === 'true';
          $trigger.attr('aria-expanded', String(!isOpen));
          $menu.attr('aria-hidden', String(isOpen));
        });

        $(document).on('click.ouigoHeaderAccount', function (event) {
          if (!$(event.target).closest($trigger.parent()).length) {
            $trigger.attr('aria-expanded', 'false');
            $menu.attr('aria-hidden', 'true');
          }
        });

        $(document).on('keydown.ouigoHeaderAccount', function (event) {
          if (event.key === 'Escape' && $trigger.attr('aria-expanded') === 'true') {
            $trigger.attr('aria-expanded', 'false');
            $menu.attr('aria-hidden', 'true');
            $trigger.trigger('focus');
          }
        });
      });

      once('ouigo-header-mobile-account-profile', '#ouigo-header-mobile-account-profile', context).forEach(function (profile) {
        if (!customer) {
          return;
        }
        var $profile = $(profile);
        $profile.find('.ouigo-header__account-initials').text(customer.initials);
        $profile.find('.ouigo-header__mobile-account-name').text(customer.fullName);
        $profile.removeAttr('hidden');
        $('#ouigo-header-mobile-account-list', context).removeAttr('hidden');
        $('#ouigo-header-mobile-account-divider', context).removeAttr('hidden');
      });

      once('ouigo-header-mobile-login-btn', '#ouigo-header-mobile-login-btn', context).forEach(function (btn) {
        if (!customer) {
          return;
        }
        var $btn = $(btn);
        var logoutUrl = $btn.data('logout-url');
        var logoutText = $btn.data('logout-text');
        if (logoutUrl) {
          $btn
            .attr('href', logoutUrl)
            .find('.ouigo-header__mobile-login-btn-text').text(logoutText).end()
            .find('.ouigo-header__account-link-icon').removeAttr('hidden');
        }
      });
    }
  };

})(jQuery, Drupal, once);
